// extracted by mini-css-extract-plugin
module.exports = {"container":"_3O4csE5N1a9Fgx45gzz5Jv","label":"HIYKvE68DxiQ3bFtAhOgx"};